import React, { useEffect } from 'react';
import isEmpty from 'lodash/isEmpty';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import {
  viewJob, existsEmptyTasks, existsEmptyRules, saveJob
} from 'store/Jobs/actions';
import {
  selectJobName, selectJobModel, selectJobTasks, selectJobRules, selectJobId, selectJobPipelines
} from 'store/Jobs/selectors';
import { closeModal, openModal } from 'store/modals/actions';
import { MODAL_SAVE_JOB } from 'store/modals/modals';
import SaveJobAlert from 'Screens/Automation/Jobs/components/Detail/components/SaveJobAlert';
import ReduxModal from 'Common/Components/ReduxModal';
import { redirect } from 'store/Router/actions';
import { setRedirectTo } from 'store/Pipelines/actions';
import { selectRedirectTo } from 'store/Pipelines/selectors';
import {
  Wrapper, WrapperTitle, Title, Id, WrapperButtons, CancelButton, CustomBlueButton
} from './styled';

const Header = () => {
  const id = useSelector(selectJobId);
  const name = useSelector(selectJobName);
  const model = useSelector(selectJobModel);
  const tasks = useSelector(selectJobTasks);
  const rules = useSelector(selectJobRules);
  const pipelines = useSelector(selectJobPipelines);
  const redirectToPipeline = useSelector(selectRedirectTo);

  const dispatch = useDispatch();
  const intl = useIntl();

  useEffect(() => () => {
    dispatch(closeModal(MODAL_SAVE_JOB));
  }, [dispatch]);

  const allowSaveJob = () => !isEmpty(name) &&
    !isEmpty(model) &&
    !isEmpty(tasks.filter((t) => !t.deleted)) &&
    !existsEmptyTasks(tasks) &&
    !isEmpty(rules) &&
    !existsEmptyRules(rules);

  const handleSaveJob = () => {
    if (id === 0) {
      dispatch(saveJob(true));
    } else if (isEmpty(pipelines)) dispatch(saveJob(false));
    else dispatch(openModal(MODAL_SAVE_JOB));
  };

  const handleCancel = () => {
    if (isEmpty(redirectToPipeline)) {
      dispatch(viewJob(null));
      dispatch(redirect('/automation/jobs'));
    } else {
      dispatch(redirect(redirectToPipeline));
      dispatch(setRedirectTo(''));
    }
  };

  return (
    <Wrapper>
      <WrapperTitle>
        <Title>Job Editor</Title>
        <Id>{ `Job ID = ${id}`}</Id>
      </WrapperTitle>
      <WrapperButtons>
        <CancelButton onClick={ handleCancel }>{ intl.formatMessage({ id: 'pipelines.detail.header.cancelButton' }) }</CancelButton>
        <CustomBlueButton disabled={ !allowSaveJob() } onClick={ handleSaveJob } label={ intl.formatMessage({ id: 'pipelines.detail.header.saveButton' }) } />
      </WrapperButtons>
      <ReduxModal id={ MODAL_SAVE_JOB }>
        <SaveJobAlert />
      </ReduxModal>
    </Wrapper>
  );
};
export default Header;
